/**
 * @deprecated Only used pre-Road Runner
 */
// eslint-disable-next-line camelcase
export const baseSatelliteOffersData_TAZ_CONTRACT = {
  offerPrices: [
    {
      "LO MAXIMO": 152.99,
      localPrice: {
        "LO MAXIMO": 164.99
      }
    },
    {
      "MAS ULTRA": 82.99,
      localPrice: {
        "MAS ULTRA": 94.99
      }
    },
    {
      "MAS LATINO": 62.99,
      localPrice: {
        "MAS LATINO": 74.99
      }
    },
    {
      ENTERTAINMENT: 72.99,
      localPrice: {
        ENTERTAINMENT: 84.99
      }
    },
    {
      CHOICE: 77.99,
      localPrice: {
        CHOICE: 89.99
      }
    },
    {
      ULTIMATE: 107.99,
      localPrice: {
        ULTIMATE: 119.99
      }
    },
    {
      "OPTIMO MAS": 67.99,
      localPrice: {
        "OPTIMO MAS": 79.99
      }
    },
    {
      PREMIER: 152.99,
      localPrice: {
        PREMIER: 164.99
      }
    }
  ]
};

export const baseInternetOffersData_RR = {
  arsFee: 15,
  offerPrices: [
    {
      PREMIER: 124.99,
      byodPrice: {
        PREMIER: 134.99
      },
      benefits: [
        {
          periodMo: 1,
          discount: 25
        },
        {
          periodMo: 3,
          discount: 10
        }
      ]
    },
    {
      "OPTIMO MAS": 54.99,
      byodPrice: {
        "OPTIMO MAS": 54.99
      },
      benefits: [
        {
          periodMo: 1,
          discount: 20
        },
        {
          periodMo: 3,
          discount: 10
        }
      ]
    },
    {
      ENTERTAINMENT: 49.99,
      byodPrice: {
        ENTERTAINMENT: 49.99
      },
      benefits: [
        {
          periodMo: 1,
          discount: 35
        },
        {
          periodMo: 24,
          discount: 5
        }
      ]
    },
    {
      ULTIMATE: 84.99,
      byodPrice: {
        ULTIMATE: 89.99
      },
      benefits: [
        {
          periodMo: 1,
          discount: 25
        },
        {
          periodMo: 3,
          discount: 10
        }
      ]
    },
    {
      CHOICE: 59.99,
      byodPrice: {
        CHOICE: 59.99
      },
      benefits: [
        {
          periodMo: 1,
          discount: 25
        },
        {
          periodMo: 3,
          discount: 10
        }
      ]
    }
  ]
};

export const baseSatelliteOffersData_RR = {
  offerPrices: [
    {
      "LO MAXIMO": 152.99,
      localPrice: {
        "LO MAXIMO": 164.99
      }
    },
    {
      "MAS ULTRA": 82.99,
      localPrice: {
        "MAS ULTRA": 94.99
      }
    },
    {
      "MAS LATINO": 62.99,
      localPrice: {
        "MAS LATINO": 74.99
      }
    },
    {
      ENTERTAINMENT: 72.99,
      localPrice: {
        ENTERTAINMENT: 84.99
      }
    },
    {
      CHOICE: 77.99,
      localPrice: {
        CHOICE: 89.99
      }
    },
    {
      ULTIMATE: 107.99,
      localPrice: {
        ULTIMATE: 119.99
      }
    },
    {
      "OPTIMO MAS": 67.99,
      localPrice: {
        "OPTIMO MAS": 79.99
      }
    },
    {
      PREMIER: 152.99,
      localPrice: {
        PREMIER: 164.99
      }
    }
  ]
};
